/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TargetstemplatesidTargetTemplate model module.
 * @module model/TargetstemplatesidTargetTemplate
 * @version v0.3
 */
export default class TargetstemplatesidTargetTemplate {
  /**
   * Constructs a new <code>TargetstemplatesidTargetTemplate</code>.
   * @alias module:model/TargetstemplatesidTargetTemplate
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TargetstemplatesidTargetTemplate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TargetstemplatesidTargetTemplate} obj Optional instance to populate.
   * @return {module:model/TargetstemplatesidTargetTemplate} The populated <code>TargetstemplatesidTargetTemplate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TargetstemplatesidTargetTemplate();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('value'))
        obj.value = ApiClient.convertToType(data['value'], 'String');
      if (data.hasOwnProperty('observation_type_id'))
        obj.observationTypeId = ApiClient.convertToType(data['observation_type_id'], 'String');
      if (data.hasOwnProperty('tag_list'))
        obj.tagList = ApiClient.convertToType(data['tag_list'], ['String']);
    }
    return obj;
  }
}

/**
 * Name of the target template. This will be the default name of targets created using this template.
 * @member {String} name
 */
TargetstemplatesidTargetTemplate.prototype.name = undefined;

/**
 * Description of the target template. This will be the default description of targets created using this template.
 * @member {String} description
 */
TargetstemplatesidTargetTemplate.prototype.description = undefined;

/**
 * Value of the target template. This will be the default value of targets created using this template.
 * @member {String} value
 */
TargetstemplatesidTargetTemplate.prototype.value = undefined;

/**
 * ID of the observation type for observations linked to this target template.
 * @member {String} observationTypeId
 */
TargetstemplatesidTargetTemplate.prototype.observationTypeId = undefined;

/**
 * Add an array of strings to help manage your resources
 * @member {Array.<String>} tagList
 */
TargetstemplatesidTargetTemplate.prototype.tagList = undefined;

